export enum UploadStatusEnum {
  UPLOADING = 'uploading',
  SUCCESS = 'success',
  FAILED = 'failed',
}
export interface IFile extends File {
  uid: string;
  status?: UploadStatusEnum;
  percent?: number;
  fileType?: string; // 文件扩展名类型
  originalFile?: File; // 原始File对象引用
  objectKey?: string;
  pdfKey?: string;
  fileUrl: string;
}
// 本地文件上传的缓存
export class LocalFilesHelper {
  // 上传的文件列表
  private _files: IFile[] = [];
  // 上传之后的文件信息
  private _uploadedFileMap: Record<string, any> = {};
  constructor() {
    this._files = [];
  }
  get files(): IFile[] {
    return this._files;
  }

  get length(): number {
    return this._files.length;
  }
  get uploadedFileMap(): Record<string, any> {
    return this._uploadedFileMap;
  }

  copy() {
    return this._files.map((file) => ({ ...file }));
  }

  has(uid: string) {
    return this._files.some((file) => file.uid === uid);
  }

  add(file: IFile) {
    if (this.has(file.uid)) {
      this.update(file.uid, file);
      return;
    }
    this._files.push(file);
  }
  delete(uid: string) {
    if (!this.has(uid)) return;
    this._files = this._files.filter((file) => file.uid !== uid);
  }

  clear() {
    this._files = [];
  }

  update(uid: string, file: IFile) {
    // 更新文件
    this._files = this._files.map((item) => {
      if (item.uid === uid) {
        return { ...item, ...file };
      }
      return item;
    });
  }

  dispose() {
    this._files = [];
    this._uploadedFileMap = {};
  }
}

export const localFilesHelper = new LocalFilesHelper();
